import Core       from '@/core/Core';
import DateSimple from '@/core/types/DateSimple';
import Price      from '@/core/types/Price';
import Qty        from '@/core/types/Qty';
import VatRate    from '@/core/types/VatRate';

/**
 * Позиция заказа для графика истории цен номенклатуры — облегчённая строка orders.getPriceHistory.
 * Цена полная — одна база с тендерами для сравнения на графике; признаки НДС — для подписи
 */
class OrderPricePoint {
  id: number;

  orderId: number;

  /** Дата сделки, она же дата курса пересчёта */
  createdAt: DateSimple;

  currencyCode: string;

  price: Price;

  vatRate: VatRate;

  isVatIncluded: boolean | null;

  qty: Qty;

  sellerName: string;

  /** Заказ по итогам тендера */
  tenderId: number | null;

  /** Как в цене учтён НДС: у поставщиков бывает и включён, и сверху, и без — подпись объясняет расхождение цен */
  get vatNote(): string {
    if (this.vatRate.isPositive() === false) {
      return 'нет';
    } else if (this.isVatIncluded === true) {
      return `${this.vatRate.format()}, включён`;
    } else {
      return `${this.vatRate.format()}, сверху`;
    }
  }

  static fromServer(data: any, result = new OrderPricePoint()): OrderPricePoint {
    result.id = data.id;
    result.orderId = data.orderId;
    result.createdAt = Core.utils.hydrate(data.createdAt, DateSimple.fromServer)!;
    result.currencyCode = data.currencyCode;
    result.price = Price.fromServer(data.price);
    result.vatRate = VatRate.fromServer(data.vatRate);
    result.isVatIncluded = data.isVatIncluded;
    result.qty = Qty.fromServer(data.qty);
    result.sellerName = data.sellerName;
    result.tenderId = data.tenderId;

    return result;
  }
}

export default OrderPricePoint;
